function ReadMoreTrigger(container) {
    this.container = container;

    const trigger = this.container.querySelector('.jsReadMoreTrigger');
    const wrapper = this.container.querySelector('.jsReadMoreWrapper');

    if (trigger) {
        trigger.addEventListener('click', _ => {
            trigger.classList.toggle('open');
            wrapper.classList.toggle('open');
        });
    
        window.addEventListener('resize', _ => {
            if (window.innerWidth >= 850) {
                trigger.classList.remove('open');
                wrapper.classList.remove('open');
            }
        });
    }
}